import * as yup from 'yup';
import { EExtendedFieldTypes, EFormFieldsNames } from '../../../types/requestForm';
export var DUPLICATE_OFFER_LINK_FIELD = {
  field: {
    label: 'Ссылка на объявление-дубликат',
    name: EFormFieldsNames.DuplicateOfferLink,
    type: EExtendedFieldTypes.TextAreaField,
    required: true,
    textArea: {
      height: 'min',
      resize: 'vertical',
      maxLength: 2048
    }
  },
  validation: yup.string().required('Введите ссылку на объявление-дубликат')
};